import styled from 'styled-components';
export const ContactInfoParent = styled.div`
    ${'' /* display:flex; */}
    ${'' /* flex-direction:column; */}
    ${'' /* background:red; */}
    ${'' /* justify-content:center; */}
`;